import { format } from 'date-fns';
import { useEffect, useState } from "react";
import riderService from 'src/services/riderService';

export default function RiderDetail({ riderId, isOpen, onClose }) {

    const [riderDetail, setRiderDetail] = useState();

    useEffect(() => {
        riderService.getRiderDetail(riderId).then((res) => {
            if (res.status == 200) {
                setRiderDetail(res.data);

            }
        })
    }, [])

    
    return (

        <div className={`fixed inset-0 ${isOpen ? 'block' : 'hidden'}`}>
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="absolute inset-0 flex items-center justify-center">

                <div className="bg-white p-6 rounded-lg shadow-lg max-h-full overflow-y-auto w-96">
                    {riderDetail ? (
                        <div className="flex justify-center">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-auto ">
                                <div className="flex items-center justify-center mb-4 ">
                                    <img
                                        src={riderDetail.image_url || "/assets/images/person.png"}
                                        alt="User Avatar"
                                        className="w-32 h-32 rounded-full border-4 border-blue-500"
                                    />
                                </div>
                                <h2 className="text-2xl font-semibold mb-2">{riderDetail.full_name}</h2>
                                <div className="mb-4 text-gray-600">
                                    <div className="mb-2">
                                        <strong>Email:</strong> {riderDetail.email}
                                    </div>
                                    <div className="mb-2">
                                        <strong>User Type:</strong> {riderDetail.account_type}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Phone:</strong> {riderDetail.phone_number || "No Phone Number"}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Gender:</strong> {riderDetail.gender || "Not Added"}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Address:</strong> {riderDetail.address || "Not Added"}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Date of Birth:</strong> {format(new Date(riderDetail.date_of_birth), 'dd/MM/yyyy')}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Status:</strong> {riderDetail.status || ""}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Joining Date:</strong>  {format(new Date(riderDetail.created_at), 'dd/MM/yyyy')}
                                    </div>
                                    <div className="mb-2">
                                        <strong>Last Updated:</strong>  {format(new Date(riderDetail.updated_at), 'dd/MM/yyyy')}
                                    </div>
                                    {/* <div className="flex flex-col items-center justify-center mb-4">
                                        <div className="mb-2">
                                            <strong>Is Phone Verified</strong>
                                        </div>
                                        {riderDetail.is_phone_verified == 0 ? (
                                            <div className="text-red-500">
                                                <img
                                                    src="/assets/images/delete-button.png"
                                                    alt="Not Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-red-500"
                                                />
                                                <p className="mt-2">Not Verified</p>
                                            </div>
                                        ) : (
                                            <div className="text-green-500">
                                                <img
                                                    src="/assets/images/approved.png"
                                                    alt="Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-blue-500"
                                                />
                                                <p className="mt-2">Verified</p>
                                            </div>
                                        )}
                                    </div> */}

                                    {/* <div className="flex flex-col items-center justify-center mb-4">
                                        <div className="mb-2">
                                            <strong>Is Email Verified</strong>
                                        </div>
                                        {riderDetail.is_email_verified == 0 ? (
                                            <div className="text-red-500">
                                                <img
                                                    src="/assets/images/delete-button.png"
                                                    alt="Not Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-red-500"
                                                />
                                                <p className="mt-2">Not Verified</p>
                                            </div>
                                        ) : (
                                            <div className="text-green-500">
                                                <img
                                                    src="/assets/images/approved.png"
                                                    alt="Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-blue-500"
                                                />
                                                <p className="mt-2">Verified</p>
                                            </div>
                                        )}
                                    </div> */}
                                    {
                                        riderDetail.document_image && riderDetail.document_image.vehicle_number && (
                                            <div className="mb-2">
                                                <strong>Vehicle Number:</strong> {riderDetail.document_image.vehicle_number || ""}
                                            </div>
                                        )
                                    }

                                    <div className="max-w-xs mx-auto">
                                        <div className="mb-2">
                                            <strong>Document Image</strong>
                                        </div>
                                        {riderDetail.document_image != null ? (
                                            <img src={riderDetail.document_image.license_front_page_image_url} className="w-full h-auto" />
                                        ) : (
                                            <div className="bg-gray-300 w-full h-64 flex items-center justify-center">
                                                No Image Available
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex flex-col items-center justify-center mb-4">

                                        <div className="mb-2">
                                            <strong>Is Document Verified</strong>
                                        </div>
                                        {riderDetail.document_image != null ? (
                                            riderDetail.document_image.is_valid_document == 0 ? (
                                                <div className="text-red-500">
                                                    <img
                                                        src="/assets/images/delete-button.png"
                                                        alt="Not Verified"
                                                        className="w-20 h-20 rounded-full border-4 border-red-500"
                                                    />
                                                    <p className="mt-2">Not Verified</p>
                                                </div>
                                            ) : (
                                                <div className="text-green-500">
                                                    <img
                                                        src="/assets/images/approved.png"
                                                        alt="Verified"
                                                        className="w-20 h-20 rounded-full border-4 border-blue-500"
                                                    />
                                                    <p className="mt-2">Verified</p>
                                                </div>
                                            )

                                        ) : (
                                            <div className="text-red-500">
                                                <img
                                                    src="/assets/images/delete-button.png"
                                                    alt="Not Verified"
                                                    className="w-20 h-20 rounded-full border-4 border-red-500"
                                                />
                                                <p className="mt-2">Not Verified</p>
                                            </div>

                                        )}
                                    </div>
                                    <button
                                        onClick={onClose}
                                        className="bg-red-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                    >
                                        Close
                                    </button>
                                </div>

                            </div>

                        </div>
                    ) : (
                        <>
                        </>
                    )}

                </div>
            </div>
        </div>
    );
}

// export async function getServerSideProps(context) {
//     const { riderId } = context.query;

//     return {
//         props: {
//             riderId: riderId || null, // Handle the case where id is undefined
//         },
//     };
// }